import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ShoppingCart, ArrowRight } from "lucide-react";

export const GiftCardItem = ({ card }) => {
  const navigate = useNavigate();

  const formatPrice = (price) => {
    return new Intl.NumberFormat('fr-HT', {
      style: 'decimal',
      minimumFractionDigits: 0,
    }).format(price);
  };

  return (
    <div 
      className="card-hover relative overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-lg group"
      data-testid={`gift-card-${card.denomination}`}
    >
      {/* Card Visual */}
      <div className="gift-card-visual h-48 p-6 flex flex-col justify-between">
        {/* Amazon Logo Area */}
        <div className="flex justify-between items-start">
          <div className="text-white">
            <span className="text-xs uppercase tracking-widest opacity-70">Amazon</span>
            <p className="text-2xl font-bold amazon-text">Gift Card</p>
          </div>
          <div className="w-12 h-12 rounded-full bg-[#FF9900] flex items-center justify-center shadow-lg">
            <span className="text-black font-bold text-lg">$</span>
          </div>
        </div>

        {/* Amount Badge */}
        <div className="flex items-end justify-between">
          <div className="amount-badge text-3xl">
            ${card.denomination}
          </div>
          <span className="text-white/60 text-sm">USD</span>
        </div>
      </div>

      {/* Card Details */}
      <div className="p-6">
        <div className="flex items-center justify-between mb-4">
          <div>
            <p className="text-gray-500 text-sm">Pri an Goud</p>
            <p className="text-2xl font-bold text-[#232F3E] price-tag">
              {formatPrice(card.price_htg)} <span className="text-base font-normal text-gray-500">HTG</span>
            </p>
          </div>
        </div>

        <Button
          onClick={() => navigate(`/checkout/${card.id}`)}
          className="w-full bg-[#FF9900] hover:bg-[#F08C00] text-black font-bold py-6 text-lg group-hover:shadow-lg transition-shadow"
          data-testid={`buy-card-${card.denomination}`}
        >
          <ShoppingCart className="w-5 h-5 mr-2" />
          Achte Kounye a
          <ArrowRight className="w-5 h-5 ml-2 opacity-0 group-hover:opacity-100 transition-opacity" />
        </Button>
      </div>
    </div>
  );
};
